// gameLogic.js
export class SokobanGame {
    constructor(level) {
      this.level = level;
      this.playerPosition = this.findPlayerPosition();
      this.originalLevel = JSON.parse(JSON.stringify(level));
      this.moves = 0;
      this.boxesOnTargets = 0;
      this.totalTargets = this.countTargets();
    }
  
    findPlayerPosition() {
      for (let y = 0; y < this.level.length; y++) {
        for (let x = 0; x < this.level[y].length; x++) {
          if (this.level[y][x] === 'P' || this.level[y][x] === 'PS') {
            return { x, y };
          }
        }
      }
      return null;
    }
  
    countTargets() {
      let count = 0;
      for (let y = 0; y < this.level.length; y++) {
        for (let x = 0; x < this.level[y].length; x++) {
          if (this.level[y][x] === 'T' || this.level[y][x] === 'PS' || this.level[y][x] === 'BS') {
            count++;
          }
        }
      }
      return count;
    }
  
    movePlayer(dx, dy) {
      const newX = this.playerPosition.x + dx;
      const newY = this.playerPosition.y + dy;
  
      // Check if move is within bounds
      if (newY < 0 || newY >= this.level.length || newX < 0 || newX >= this.level[0].length) {
        return false;
      }
  
      const targetCell = this.level[newY][newX];
  
      // If target is a wall, cannot move
      if (targetCell === 'W') {
        return false;
      }
  
      // If target is a box, check if we can push it
      if (targetCell === 'B' || targetCell === 'BS') {
        const boxNewX = newX + dx;
        const boxNewY = newY + dy;
  
        // Check if box can be pushed
        if (!this.canPushBox(boxNewX, boxNewY)) {
          return false;
        }
  
        // Push the box
        this.pushBox(newX, newY, boxNewX, boxNewY);
      }
  
      // Move the player
      this.updatePlayerPosition(newX, newY);
      this.moves++;
      
      return true;
    }
  
    canPushBox(x, y) {
      // Check if within bounds
      if (y < 0 || y >= this.level.length || x < 0 || x >= this.level[0].length) {
        return false;
      }
      
      const cell = this.level[y][x];
      // Can push box to empty space or target, but not to wall or another box
      return cell === ' ' || cell === 'T';
    }
  
    pushBox(fromX, fromY, toX, toY) {
      const fromCell = this.level[fromY][fromX];
      const toCell = this.level[toY][toX];
  
      // Update box count if moving from/to target
      if (fromCell === 'BS') {
        this.boxesOnTargets--;
      }
      if (toCell === 'T') {
        this.boxesOnTargets++;
      }
  
      // Move the box
      if (toCell === 'T') {
        this.level[toY][toX] = 'BS'; // Box on target
      } else {
        this.level[toY][toX] = 'B'; // Box
      }
  
      // Clear old box position
      if (fromCell === 'BS') {
        this.level[fromY][fromX] = 'T'; // Target
      } else {
        this.level[fromY][fromX] = ' '; // Empty
      }
    }
  
    updatePlayerPosition(newX, newY) {
      const currentX = this.playerPosition.x;
      const currentY = this.playerPosition.y;
      const currentCell = this.level[currentY][currentX];
      const newCell = this.level[newY][newX];
  
      // Clear old player position
      if (currentCell === 'PS') {
        this.level[currentY][currentX] = 'T'; // Target
      } else {
        this.level[currentY][currentX] = ' '; // Empty
      }
  
      // Set new player position
      if (newCell === 'T' || newCell === 'BS') {
        this.level[newY][newX] = 'PS'; // Player on target
      } else {
        this.level[newY][newX] = 'P'; // Player
      }
  
      this.playerPosition = { x: newX, y: newY };
    }
  
    isGameWon() {
      return this.boxesOnTargets === this.totalTargets;
    }
  
    reset() {
      this.level = JSON.parse(JSON.stringify(this.originalLevel));
      this.playerPosition = this.findPlayerPosition();
      this.moves = 0;
      this.boxesOnTargets = 0;
      this.totalTargets = this.countTargets();
    }
  
    getState() {
      return {
        level: JSON.parse(JSON.stringify(this.level)),
        moves: this.moves,
        boxesOnTargets: this.boxesOnTargets,
        totalTargets: this.totalTargets,
        isWon: this.isGameWon()
      };
    }
  }
  
  export const LEVELS = [
    // Level 1 - Simple
    [
      ['W', 'W', 'W', 'W', 'W', 'W', 'W'],
      ['W', ' ', ' ', ' ', ' ', ' ', 'W'],
      ['W', ' ', 'B', 'T', 'B', ' ', 'W'],
      ['W', ' ', 'T', 'P', 'T', ' ', 'W'],
      ['W', ' ', 'B', 'T', 'B', ' ', 'W'],
      ['W', ' ', ' ', ' ', ' ', ' ', 'W'],
      ['W', 'W', 'W', 'W', 'W', 'W', 'W']
    ],
    // Level 2 - Easier
    [
      ['W', 'W', 'W', 'W', 'W', 'W', 'W', 'W'],
      ['W', ' ', ' ', ' ', ' ', ' ', ' ', 'W'],
      ['W', ' ', 'B', 'B', 'B', ' ', ' ', 'W'],
      ['W', ' ', ' ', ' ', ' ', ' ', ' ', 'W'],
      ['W', ' ', 'T', 'T', 'T', ' ', ' ', 'W'],
      ['W', ' ', ' ', 'P', ' ', ' ', ' ', 'W'],
      ['W', ' ', ' ', ' ', ' ', ' ', ' ', 'W'],
      ['W', 'W', 'W', 'W', 'W', 'W', 'W', 'W']
    ],
    // Level 3 - Even simpler
    [
      ['W', 'W', 'W', 'W', 'W', 'W'],
      ['W', ' ', ' ', ' ', ' ', 'W'],
      ['W', ' ', 'B', 'T', ' ', 'W'],
      ['W', ' ', 'P', ' ', ' ', 'W'],
      ['W', ' ', ' ', ' ', ' ', 'W'],
      ['W', 'W', 'W', 'W', 'W', 'W']
    ]
  ];